import gql from 'graphql-tag';

export const MY_VERTICALS_RESILIENCE_PULSE_CHECK = gql`
  query myVerticalResiliencePulseCheck {
    myVerticalResiliencePulseCheck
  }
`;
